import api from './api';
import types from './mutation-types';

export default {
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchMm01List',
						value: data.body.SRCH_DD_01 || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'carScnList',
						value: data.body.CAR_SCN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pacScnList',
						value: data.body.PAC_SCN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchMm02List',
						value: data.body.SRCH_DD_02 || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'saleRegnList',
						value: data.body.OCCU_REGN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'flclSpcList',
						value: data.body.FLCL_SPC || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'cTypeList',
						value: data.body.CTYPE || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'phmnCdList',
						value: data.body.PHMN_CD || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'partTypeList',
						value: data.body.PART_G || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'prcsStepList',
						value: data.body.PRCS_STEP || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'prcsRsltList',
						value: data.body.PRCS_RSLT || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'idxScnList',
						value: data.body.IDX_SCN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'ceqTypeList',
						value: data.body.CEQ_TYPE || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'useTermList',
						value: data.body.USE_TERM || []
					});
					// commit(types.DEFAULT_ASSIGN, {
					// 	key: 'carTypeNmList',
					// 	value: data.body.CAR_TYPE_NM || []
					// });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getCommCodeDetails_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodeDetails(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParamInit_({ commit }) {
		commit(types.SEARCH_PARAM_INIT);
	},
	getgrdList_({ commit, state }) {
		const { searchParams, pagingInfo } = state;

		return api
			.getgrdList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList',
						value: data.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
